const fields = [
  {
    key: 'name',
    type: 'input',
    templateOptions: {
      label: 'name'
    }
  },
  {
    key: 'link',
    type: 'input',
    templateOptions: {
      label: 'link'
    }
  },
  {
    key: 'showOnWebsiteLandingPage',
    type: 'boolean',
    templateOptions: {
      label: 'showOnWebsiteLandingPage'
    }
  },
  {
    key: 'showOnWebsiteFooter',
    type: 'boolean',
    templateOptions: {
      label: 'showOnWebsiteFooter'
    }
  },
  {
    key: 'showOnLivestreamGraphicSponsorOverlay',
    type: 'boolean',
    templateOptions: {
      label: 'showOnLivestreamGraphicSponsorOverlay'
    }
  }
]

export default fields
